import { useState } from 'react';
import { FileDown, Loader2 } from 'lucide-react';

import { apiDownload } from '@/api/client';
import { toast } from '@/ui/Toast';

/** Downloads the research on screen (the current run, or the earlier one being viewed) as a PDF in GFT's template. */
export function ExportPdfButton({ ideaId, researchId, current }: { ideaId: string; researchId: string; current: boolean }) {
  const [pending, setPending] = useState(false);
  const download = () => {
    setPending(true);
    const query = current ? '' : `?research_id=${researchId}`;
    apiDownload(`/api/ideas/${ideaId}/export.pdf${query}`, 'research.pdf')
      .catch((error: unknown) => toast.error('Could not export the PDF', error instanceof Error ? error.message : undefined))
      .finally(() => setPending(false));
  };
  return (
    <button
      type="button"
      className="btn btn-secondary btn-sm"
      disabled={pending}
      title={current ? 'Download this research as a PDF in the GFT template' : 'Download this earlier run as a PDF in the GFT template'}
      onClick={download}
    >
      {pending ? <Loader2 aria-hidden="true" className="spin" /> : <FileDown aria-hidden="true" />}
      {pending ? 'Exporting…' : 'Export PDF'}
    </button>
  );
}
